module.exports = __webpack_public_path__ + "img/photoTexture.a45741e7.png";